import React from 'react';
import styled from 'styled-components';
import { ZTooltip } from '../ztooltip';
import Sparkles from '../svg/sparkles';
import Crown from '../svg/crown';

export const BaseCardTag = styled.span`
    color: white;
    display: inline-flex;
    align-items: center;
    border-radius: 10px;
    font-size: 10px;
    padding: 4px 8px;
    font-weight: 600;
    margin-left: 5px;
    text-decoration: none;
    min-width: fit-content;
    letter-spacing: 0.3px;
    line-height: 1;
    white-space: nowrap;
`;

export const NewTag = styled(BaseCardTag)`
    background-color: #00afdb;
`;

export const ComingSoonTag = styled(BaseCardTag)`
    background-color: #ff9800;
`;

export const EarlyAccessTag = styled(BaseCardTag)`
    background-color: #18bb18da;
`;

export const AiTag = styled(BaseCardTag)`
    background: linear-gradient(90deg, #3b82f6 3.75%, #8b5cf6 103.75%);
`;

const AiSparklesContainer = styled.div`
    display: inline-flex;
    justify-content: center;
    align-items: center;
`;

const _aiSparklesTag = ({ className }: { className?: string }) => {
    return (
        <ZTooltip title={'Smart feature powered by AI.'} position={'top'}>
            <AiSparklesContainer className={className}>
                <Sparkles />
            </AiSparklesContainer>
        </ZTooltip>
    );
};

export const AiSparklesTag = styled(_aiSparklesTag)``;

const CrownUpgradeContainer = styled.div`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 16px;
    margin-left: 0;

    svg {
        fill: #f0047f !important;
    }
`;

const _crownBadgeTag = ({ className, tooltip }: { className?: string; tooltip?: React.ReactNode }) => {
    const content = (
        <CrownUpgradeContainer className={className}>
            <Crown />
        </CrownUpgradeContainer>
    );

    return tooltip ? (
        <ZTooltip html={tooltip} position='top'>
            {content}
        </ZTooltip>
    ) : (
        content
    );
};

export const CrownBadgeTag = styled(_crownBadgeTag)``;
